import { createSlice } from "@reduxjs/toolkit";
import {
  REQUEST_GET_STATES,
  RECEIVE_GET_STATES,
  RECEIVE_GET_STATES_ERROR,
} from "@/redux/constants/parameters";

/**
 * Bridge slice — maintains the same `state.states` shape so existing consumers
 * (selectors, legacy components) keep working while the module migrates to RTK Query.
 */
const statesSlice = createSlice({
  name: "states",
  initialState: {
    states: [],
    error: null,
    isFetching: false,
  },
  reducers: {
    setStates(state, action) {
      state.states = action.payload;
      state.isFetching = false;
    },
    setFetching(state) {
      state.isFetching = true;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(REQUEST_GET_STATES, state => {
        state.isFetching = true;
      })
      .addCase(RECEIVE_GET_STATES, (state, action) => {
        state.states = action.states;
        state.isFetching = false;
      })
      .addCase(RECEIVE_GET_STATES_ERROR, (state, action) => {
        state.error = action.error;
        state.isFetching = false;
      });
  },
});

export const { setStates, setFetching, setError } = statesSlice.actions;
export default statesSlice.reducer;

